import { render, staticRenderFns } from "./Searching.vue?vue&type=template&id=60cbb644&scoped=true"
import script from "./Searching.vue?vue&type=script&lang=js"
export * from "./Searching.vue?vue&type=script&lang=js"
import style0 from "./Searching.vue?vue&type=style&index=0&id=60cbb644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cbb644",
  null
  
)

export default component.exports